import { Table } from 'reactstrap';
import { Protest, openInNewTab, protestOutcomeToText, protestStatusToText, protestTypeToText } from '../types/Protest';
import moment from 'moment';

interface ProtestTableProps {
  protests: Protest[];
}

const ProtestTable = (props: ProtestTableProps) => {
  return (
    <Table dark>
      <thead>
        <tr>
          <th>Game</th>
          <th>Type</th>
          <th>Event Type</th>
          <th>Being Protested</th>
          <th>Raised By</th>
          <th>Timestamp</th>
          <th>Reason</th>
          <th>Status</th>
          <th>Outcome</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(props.protests) && props.protests.map(p => (
          <tr onClick={() => openInNewTab(p._id)} key={p._id}>
            <td>{p.game}</td>
            <td>{protestTypeToText(p.protestType)}</td>
            <td>{p.eventType}</td>
            <td>{p.protesteeUsername}</td>
            <td>{p.protesterUsername}</td>
            <td>{moment.unix(p.timestamp).format("DD/MM/YYYY hh:mm:ss")}</td>
            <td>{p.protestReason}</td>
            <td>{protestStatusToText(p.status)}</td>
            <td>{protestOutcomeToText(p.outcome)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default ProtestTable;